import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useParams, Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Typography,
} from '@mui/material';
import { useQuery } from '../../utils';
import { postAllOpposAction } from '../../actions/dealDailyOpposPostAllAction';
import { AppLogo } from '../../constants/AppLogo';
import Error from '../error/Error';
import { regexObjectId } from '../../constants/formats';

const AllOpportunities = ({ postAllOppos, oppoPostAll }) => {
  const { pending, success, error } = oppoPostAll;
  const { restId } = useParams();

  const query = useQuery();
  const date = query.get('date');
  const [idError, setIdError] = useState('');

  useEffect(() => {
    if (!restId) {
      return;
    }

    if (!regexObjectId.test(restId)) {
      setIdError('Invalid restaurant ID');
      return;
    }

    postAllOppos(restId, date);
  }, []);

  const renderContent = () => {
    if (idError) {
      return (
        <Box display='flex' alignItems='center' justifyContent='center'>
          <Typography variant='h6'>{idError}</Typography>
        </Box>
      );
    }

    if (pending) {
      return (
        <Box display='flex' alignItems='center' justifyContent='center'>
          <CircularProgress color='primary' size={22} style={{ marginRight: '1rem' }} />
          <Typography variant='h6'>Posting Deals</Typography>
        </Box>
      );
    }

    if (success) {
      return (
        <Box style={{ textAlign: 'center' }}>
          <Box style={{ marginBottom: '1rem' }}>
            <Typography variant='h6'>Complete</Typography>
            <Typography>Your deals have been posted</Typography>
          </Box>

          <Button component={Link} to='/deals' color='primary' variant='contained'>
            View in Partner Portal
          </Button>
        </Box>
      );
    }

    return null;
  };

  return (
    <Container maxWidth='sm'>
      <Box justifyContent='center' style={{ padding: '3rem 0 2rem', textAlign: 'center' }}>
        <Box height='35px'>
          <AppLogo style={{ height: 35 }} />
        </Box>
      </Box>

      <Card>
        <CardContent>
          {Boolean(error) && <Error error={error} message={error} />}
          {renderContent()}
        </CardContent>
      </Card>
    </Container>
  );
};

AllOpportunities.propTypes = {
  postAllOppos: PropTypes.func.isRequired,
  oppoPostAll: PropTypes.shape({
    // data: PropTypes.arrayOf(),
    pending: PropTypes.bool,
    error: PropTypes.string,
    success: PropTypes.bool,
  }).isRequired,
};

const mapStateToProps = (state) => ({ oppoPostAll: state.dealDailyOppoPostAll });
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ postAllOppos: postAllOpposAction }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(AllOpportunities);
